import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  ClientsPage,
  HomePage,
  UsersPage,
  ProductsPage,
  InventoryPage,
  InfrastructurePage,
} from './pages';

const DashboardPage = (): JSX.Element => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}${ROUTES.dashboard.users.root}`} component={UsersPage} />
      <Route path={`${path}${ROUTES.dashboard.clients.root}`} component={ClientsPage} />
      <Route path={`${path}${ROUTES.dashboard.products.root}`} component={ProductsPage} />
      <Route path={`${path}${ROUTES.dashboard.inventory.root}`} component={InventoryPage} />
      <Route path={`${path}${ROUTES.dashboard.infrastructure.root}`} component={InfrastructurePage} />
      <Route path={`${path}`} exact component={HomePage} />
    </Switch>
  );
};

export default DashboardPage;
